module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_3009.8f42d1ff.png";